import React from 'react';
import { CollapsingContainer } from '../elements-container/collapsing-container';
import { FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

const CollapsingDescription = ({ description, textSmall = false, collapsedHeight }) => {
  return (
    <CollapsingContainer
      collapsedHeight={collapsedHeight || 50}
      showText={
        <FormattedMessage
          id="listing.production_faq.read_more"
          defaultMessage="Read more"
        />
      }
      hideText={
        <FormattedMessage
          id="listing.production_faq.hide"
          defaultMessage="Hide"
        />
      }
      textSmall={textSmall}
    >
      <div className={textSmall ? 'text-gray-600 description text-small' : 'text-gray-600 description'}>
        {description}
      </div>
    </CollapsingContainer>
  );
};

CollapsingDescription.propTypes = {
  description: PropTypes.string,
  collapsedHeight: PropTypes.number,
  textSmall: PropTypes.bool
};

export default injectIntl(CollapsingDescription);
